export default __webpack_public_path__ + "static/step_img_2-4a49e5b332d09edd264c538f152301bc.png";